import {
  ControlledIsoCodeMappingInput,
  IControlledIsoCodeMappingInputProps,
} from '@host/components/iso-code-mapping-input/ControlledIsoCodeMappingInput'
import { ControlledIsoCodeMappingInputWithDetails } from '@host/components/iso-code-mapping-input/ControlledIsoCodeMappingInputWithDetails'
import { IsoCodeMappingResponseDto, IsoCodeMappings, useAdminStore } from '@tom-ui/admin'

import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { FieldValues } from 'react-hook-form'

export const renderIsoCodeMappingInput = <T extends FieldValues>(
  props: IControlledIsoCodeMappingInputProps<T>,
): React.ReactElement => <ControlledIsoCodeMappingInput {...props} />

export const renderIsoCodeMappingInputWithDetails = <T extends FieldValues>(
  props: IControlledIsoCodeMappingInputProps<T>,
): React.ReactElement => <ControlledIsoCodeMappingInputWithDetails {...props} />

export const IsoCodeMappingWrapper: FC = observer(() => {
  const { isoCodeMappingStore } = useAdminStore()
  const onFilter = async (value: string): Promise<IsoCodeMappingResponseDto | null> =>
    (await isoCodeMappingStore.getContainerCharacteristicsByIsoCode(value?.toUpperCase())) ?? null

  return <IsoCodeMappings onFilter={onFilter} />
})
